export const WEGO_JOINTS = {
  RIGHT_SHOULDER: { label: '右肩', index: 0, color: '#ff6384', default: -20, min: -360, max: 360, isMotor: true },
  LEFT_SHOULDER: { label: '左肩', index: 1, color: '#ff9f40', default: 20, min: -360, max: 360, isMotor: true },
  RIGHT_HIP: { label: '右股関節', index: 2, color: '#ffcd56', default: -10, min: -118.8, max: 91.2, isMotor: true },
  RIGHT_ANKLE_PITCH: { label: '右足首上下', index: 3, color: '#22cfcf', default: -10, min: -77.7, max: 75.6, isMotor: true },
  RIGHT_ANKLE_ROLL: { label: '右足首左右', index: 4, color: '#36a2eb', default: 0, min: -18.4, max: 47.5, isMotor: true },
  LEFT_HIP: { label: '左股関節', index: 5, color: '#9a66ff', default: 10, min: -91.2, max: 118.8, isMotor: true },
  LEFT_ANKLE_PITCH: { label: '左足首上下', index: 6, color: '#c9cbcf', default: 10, min: -75.6, max: 77.7, isMotor: true },
  LEFT_ANKLE_ROLL: { label: '左足首左右', index: 7, color: '#333333', default: 0, min: -47.5, max: 18.4, isMotor: true },
  HEAD_CAB: { label: '頭', index: 8, color: '#4a9878', default: 0, min: -60, max: 0, isMotor: false },
  USB_COVER: { label: 'USBカバー', index: 9, color: '#888888', default: 0, min: 0, max: 100, isMotor: false },
  HEAD_BUTTON: { label: '頭ボタン', index: 10, color: '#ff0000', default: 0, min: -0.05, max: 0, isMotor: false },
} as const;

export const JOINT_VID_MAP: Record<string, number> = Object.fromEntries(
  Object.entries(WEGO_JOINTS)
    .filter(([, joint]) => joint.isMotor)
    .map(([jointId, joint]) => [jointId, joint.index]),
);
